import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import PublicLayout from '../PublicLayout';

function PublicRoute (props) {
  const {
    component: Component, forceGuest, noRedirect, booking, ...rest
  } = props;

  if (forceGuest && !noRedirect) {
    return (
      <Route
        {...rest}
        render={() => (
          <Redirect to="/dashboard" />
        )}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <PublicLayout booking={booking} {...matchProps}>
          <Component {...matchProps} />
        </PublicLayout>
      )}
    />
  );
}

PublicRoute.propTypes = {
  forceGuest: PropTypes.bool,
  /**
   * Indicates this page is part of the public booking process
   */
  booking: PropTypes.bool,
  /**
   * Don't automatically redirect this page
   */
  noRedirect: PropTypes.bool,
  /**
   * Component to be displayed for the rule
   */
  component: PropTypes.node.isRequired,
};

PublicRoute.defaultProps = {
  noRedirect: false,
  forceGuest: false,
  booking: false,
};

export default PublicRoute;
